import { SiDiscord, SiX, SiYoutube } from "react-icons/si"
import React from "react"
import { Telegram } from "@mui/icons-material"

export const socials = [
  {
    id: 1,
    title: "YouTube",
    link: "https://www.youtube.com/@Zombie_TD",
    icon: <SiYoutube title="YouTube" color="secondary" />,
  },
  {
    id: 2,
    title: "X.com",
    link: "https://x.com/zombie_td",
    icon: <SiX title="X.com" color="secondary" />,
  },
  {
    id: 3,
    title: "Telegram",
    link: "https://t.me/zombie_td_news/",
    icon: (
      <Telegram color="white" title="Telegram" sx={{ fontSize: "1.7rem" }} />
    ),
  },
  {
    id: 4,
    title: "Discord",
    link: "https://discord.gg/G9Sh8e35kG",
    icon: <SiDiscord title="Discord" color="secondary" />,
  },
]
